import {useCallback} from 'react';
import {deleteNorafUpdateByAgentId} from 'api/agentNoraf';
import {useGetTokens} from 'services/auth';

export const useDeleteNorafUpdateByAgentId = () => {
  const getTokens = useGetTokens();

  return useCallback(
    (agentId: string, mock?: boolean) => {
      return deleteNorafUpdateByAgentId(getTokens, agentId, mock);
    },
    [getTokens],
  );
};
